import { render, staticRenderFns } from "./MemberBenefit.vue?vue&type=template&id=8e777574&scoped=true&"
import script from "./MemberBenefit.vue?vue&type=script&lang=js&"
export * from "./MemberBenefit.vue?vue&type=script&lang=js&"
import style0 from "./MemberBenefit.vue?vue&type=style&index=0&id=8e777574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e777574",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
